/* eslint-disable no-underscore-dangle */
import clsx from 'clsx';
import { useRef, useCallback } from 'react';
import { useScrollIntoViewActiveChange } from 'shared/hooks/useScrollIntoViewActiveChange';
import { NavLinkButton } from '../NavLinkButton';
import { EduHubCategoryNavigationProps } from '../../types';
import styles from './EduCategoryNavigation.module.scss';

export const EduCategoryNavigation = ({
  links = [],
  activeCategory
}: EduHubCategoryNavigationProps) => {
  const activeItemRef = useRef<HTMLAnchorElement>(null);
  const navbarRef = useRef<HTMLUListElement>(null);

  useScrollIntoViewActiveChange(activeItemRef, activeCategory);

  const isActiveCategory = useCallback(
    (id: string) => id === activeCategory?._id || (id === '' && !activeCategory),
    [activeCategory]
  );

  if (links.length < 2) {
    return null;
  }

  return (
    <nav aria-label="edu-hub-categories" className={styles.nav} role="navigation" ref={navbarRef}>
      <ul className={clsx(styles.list, styles.desktop)}>
        {links.map(({ title, path, id }) => (
          <li className={styles.item} key={id}>
            <NavLinkButton
              scroll={false}
              ref={isActiveCategory(id) ? activeItemRef : undefined}
              href={path}
              className={isActiveCategory(id) ? styles.active : ''}>
              {title}
            </NavLinkButton>
          </li>
        ))}
      </ul>
      <ul className={clsx(styles.list, styles.mobile)}>
        {links.map(({ title, path, id }) => (
          <li className={styles.item} key={id}>
            <NavLinkButton
              scroll={false}
              ref={isActiveCategory(id) ? activeItemRef : undefined}
              href={path}
              className={isActiveCategory(id) ? styles.active : ''}>
              {title}
            </NavLinkButton>
          </li>
        ))}
      </ul>
    </nav>
  );
};
